module.exports = __webpack_public_path__ + "public/img/04.0e31daa2.png";